import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BANK_ACCOUNT_TYPES } from '@constants';
import { FormField } from '@components/common';

class BankAccountForm extends Component {
	constructor(props) {
		super(props);

		this.fieldStyle = {
			fieldCol   : 12,
			labelCol   : 12,
			labelClass : 'margin-bottom-5 text-left',
			groupClass : 'margin-bottom-10',
		};
		this.bankAccountTypeOptions = Object.values(BANK_ACCOUNT_TYPES);
	}

	render() {
		const {
			form,
			hideAccountType,
			onChange,
			onSubmit,
		} = this.props;

		return (
			<div className="form-horizontal">
				<FormField
					fieldStyle={this.fieldStyle}
					name="bankHolderName"
					label="Account Holder Name"
					value={form.bankHolderName.value}
					validation={form.bankHolderName.validation}
					onChange={onChange('bankHolderName', 'field')}
					onKeyPress={({ key }) => { if (key === 'Enter') onSubmit(); }}
					placeholder="John Doe"
				/>
				<FormField
					fieldStyle={this.fieldStyle}
					label="Routing Number"
					name="routingNo"
					maxLength={9}
					value={form.routingNo.value}
					validation={form.routingNo.validation}
					onChange={onChange('routingNo', 'field')}
					onKeyPress={({ key }) => { if (key === 'Enter') onSubmit(); }}
					placeholder="110000000"
				/>
				<div className="row">
					<div className="col-sm-6">
						<FormField
							fieldStyle={this.fieldStyle}
							label="Account Number"
							name="accountNo"
							value={form.accountNo.value}
							validation={form.accountNo.validation}
							onChange={onChange('accountNo', 'field')}
							onKeyPress={({ key }) => { if (key === 'Enter') onSubmit(); }}
							placeholder="000123456789"
						/>
					</div>
					<div className="col-sm-6">
						<FormField
							fieldStyle={this.fieldStyle}
							label="Confirm Account Number"
							name="accountNo_confirmation"
							value={form.accountNo_confirmation.value}
							validation={form.accountNo_confirmation.validation}
							onChange={onChange('accountNo_confirmation', 'field')}
							onKeyPress={({ key }) => { if (key === 'Enter') onSubmit(); }}
							placeholder="000123456789"
						/>
					</div>
				</div>
				<If condition={!hideAccountType}>
					<FormField
						fieldStyle={this.fieldStyle}
						controlType="select"
						options={this.bankAccountTypeOptions}
						label="Account Type"
						name="accountType"
						value={form.accountType.value}
						validation={form.accountType.validation}
						onChange={onChange('accountType', 'select')}
						placeholder="Select..."
						isClearable={false}
					/>
				</If>
			</div>
		);
	}
}

BankAccountForm.propTypes = {
	form            : PropTypes.object.isRequired,
	hideAccountType : PropTypes.bool,
	onChange        : PropTypes.func.isRequired,
	onSubmit        : PropTypes.func,
};

BankAccountForm.defaultProps = {
	hideAccountType : false,
	onSubmit        : () => {},
};

export default BankAccountForm;
